module.exports = __webpack_public_path__ + "static/ordinace_014full-b00b6a8f0b6276c721d519b043362208.jpg";